import { render, staticRenderFns } from "./layout-toolbar-new.vue?vue&type=template&id=c8f7e380&"
import script from "./layout-toolbar-new.vue?vue&type=script&lang=js&"
export * from "./layout-toolbar-new.vue?vue&type=script&lang=js&"
import style0 from "./layout-toolbar-new.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports